export const PRIMARY_COLOR = "#4285f4"
